import { render, staticRenderFns } from "./myOrderInfo.vue?vue&type=template&id=66aaf7cc&scoped=true&"
import script from "./myOrderInfo.vue?vue&type=script&lang=js&"
export * from "./myOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./myOrderInfo.vue?vue&type=style&index=0&id=66aaf7cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aaf7cc",
  null
  
)

export default component.exports